<template>
  <div class="relative bg-blueGray-100 text-emerald-800 pb-4" v-if="has('plan.summary.view')">
    <div class="mx-auto w-full" v-if="overview">

      <!-- My Wallet -->
      <h6 class="text-blueGray-500 uppercase text-xs font-bold px-4 mt-2 mb-1">My Wallet</h6>
      <div class="flex flex-wrap">
        <div v-for="wallet in walletTiles(overview.personal)" :key="'personal-' + wallet.currency" class="w-full lg:w-6/12 xl:w-3/12 px-4 mt-2">
          <card-stats
            :statSubtitle="`${wallet.currency} balance/Ledger`"
            :statTitle="`${formatAbbrCurrency({ currency: wallet.currency, amount: wallet.balance })}/${formatAbbrCurrency({ currency: wallet.currency, amount: wallet.ledger_balance })}`"
            statArrow="up"
            statCount="Personal"
            statPercentColor="text-emerald-500"
            statDescripiron="your own wallet"
            statIconName="far fa-user"
            statIconColor="bg-blueGray-900"
          />
        </div>
      </div>

      <!-- Business Wallet -->
      <template v-if="overview.business">
        <h6 class="text-blueGray-500 uppercase text-xs font-bold px-4 mt-4 mb-1">Business Wallet</h6>
        <div class="flex flex-wrap">
          <div v-for="wallet in walletTiles(overview.business)" :key="'business-' + wallet.currency" class="w-full lg:w-6/12 xl:w-3/12 px-4 mt-2">
            <card-stats
              :statSubtitle="`${wallet.currency} balance/Ledger`"
              :statTitle="`${formatAbbrCurrency({ currency: wallet.currency, amount: wallet.balance })}/${formatAbbrCurrency({ currency: wallet.currency, amount: wallet.ledger_balance })}`"
              statArrow="up"
              statCount="Business"
              statPercentColor="text-indigo-500"
              statDescripiron="your business's own wallet"
              statIconName="far fa-building"
              statIconColor="bg-blueGray-900"
            />
          </div>
        </div>
      </template>

      <!-- Cluster Total -->
      <template v-if="overview.cluster">
        <h6 class="text-blueGray-500 uppercase text-xs font-bold px-4 mt-4 mb-1">Cluster Total</h6>
        <div class="flex flex-wrap">
          <div v-for="([currency, stat], i) in Object.entries(overview.cluster)" :key="'cluster-' + i" class="w-full lg:w-6/12 xl:w-3/12 px-4 mt-2">
            <card-stats
              :statSubtitle="`${currency} balance/Ledger`"
              :statTitle="`${formatAbbrCurrency({ currency, amount: stat[0] ? stat[0].total_balance || 0 : 0 })}/${formatAbbrCurrency({ currency, amount: stat[0] ? stat[0].total_ledger_balance || 0 : 0 })}`"
              statArrow="up"
              :statCount="`${stat[0] ? stat[0].count : 0}`"
              statPercentColor="text-orange-500"
              statDescripiron="wallets in your cluster"
              statIconName="far fa-chart-bar"
              statIconColor="bg-blueGray-900"
            />
          </div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import CardStats from "@/components/Cards/CardStats.vue";
import { mapActions } from 'vuex';
import { formatAbbrCurrency } from "../../utils/formatter.util";

export default {
  components: {
    CardStats
  },
  created() {
    this.formatAbbrCurrency = formatAbbrCurrency;
  },
  mounted() {
    this.getWalletOverview().then(overview => {
      this.overview = overview;
    });
  },
  data() {
    return {
      overview: null
    };
  },
  methods: {
    ...mapActions(["getWalletOverview"]),

    // Renders a { naira: {...wallet}, usd: {...wallet} } shaped section as tiles,
    // skipping a currency entirely rather than showing a broken $0 tile if that
    // wallet somehow wasn't returned.
    walletTiles(section) {
      if (!section) return [];
      return Object.values(section)
        .filter(Boolean)
        .map(wallet => ({
          currency: wallet.base_currency,
          balance: wallet.balance,
          ledger_balance: wallet.ledger_balance
        }));
    }
  }
};
</script>
